import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-divider',
    imports: [],
    templateUrl: './divider.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './divider.component.scss'
})
export class DividerComponent {
}
